import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";

const icon = L.divIcon({
  className: "",
  html: `<div style="width:28px;height:28px;background:#FFCC00;border:2px solid #0A0A0A;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.4)"></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  popupAnchor: [0, -28],
});

export function MapView({ items = [], height = "500px", center = [-12.05, -77.04], zoom = 6 }) {
  const points = items.filter((m) => m.location?.lat && m.location?.lng);
  return (
    <div style={{ height }} className="w-full border border-border overflow-hidden" data-testid="map-view">
      <MapContainer center={center} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {points.map((m) => (
          <Marker key={m.id} position={[m.location.lat, m.location.lng]} icon={icon}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                <img src={m.images?.[0]} alt={m.name} style={{ width: "100%", height: 90, objectFit: "cover", marginBottom: 6 }} />
                <strong>{m.name}</strong>
                <div style={{ fontSize: 12, color: "#666" }}>{m.location.city} · {m.sector}</div>
                {m.price_rent_day != null && <div style={{ fontSize: 13, fontWeight: 700 }}>{m.currency} {m.price_rent_day}/día</div>}
                <Link to={`/maquinaria/${m.id}`} style={{ color: "#B8860B", fontWeight: 600, fontSize: 12 }}>Ver detalle →</Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
